import React, { useState } from "react";
import { Table, Button, Row, Col } from "reactstrap";

const SubProductsTable = ({ data, sendDataToMain  }) => {
  // 🔹 Base product details (always fixed for each sub product)
  const branch_type=data.branch_type
    const [loadInser2, setLoadInsert2] = useState(false);
  const baseData = {
    product_id: data.product_id,
    product_subcategory_list: data.product_subcategory_list,
    product_name: data.product_name,
    branch_id: data.branch_id,
    gender: data.gender,
    remarks: data.remarks,
    metal: data.metal,
    material: data.material,
    on_demand: data.on_demand,
    category_id: data.category_id,
    available: data.available,
    exhibition: data.exhibition,
    businesses: data.businesses,
    disable: data.disable,
    trial: data.trial,
    product_images: data.product_images,
    ptype:data.ptype,
    suitable:data.suitable,
    pcare:data.pcare,
    pattern:data.pattern,
    package:data.package,
    gst:data.gst,
    weight:data.weight,
  };

  const [subProducts, setSubProducts] = useState([]);

  const handleSubProductChange = (index, field, value) => {
    const updated = [...subProducts];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    setSubProducts(updated);
  };

  const handleAddSubProduct = () => {
    const newSubProduct = {
      ...baseData,
      size_length: "",
      color: "",
      qty: 0,
    //   addedQty:0,
      price: 0,
      discounted_price: 0,
      product_code: `${data.product_code}/${String(subProducts.length + 1).padStart(2, "0")}`,
    };
    setSubProducts([...subProducts, newSubProduct]);
   
  };

  const handleDeleteSubProduct = (index) => {
    const updated = subProducts.filter((_, i) => i !== index);
    const reIndexed = updated.map((sp, i) => ({
      ...sp,
      code: `${data.product_code}/${String(i + 1).padStart(2, "0")}`,
    }));
    setSubProducts(reIndexed);
  };

//   🔹 Save handler
 const handleSave = () => {
     setLoadInsert2(true);
  setTimeout(() => {
    sendDataToMain(subProducts);  
     setLoadInsert2(false);
  }, 2000);
 
};


  return (
    <>
      <Row>
        <Col sm={12}>
          <h5 className="mt-4">Sub Products</h5>
          <Table bordered>
            <thead>
              <tr>
                <th>#</th>
                <th>Size</th>
                <th>Color</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Discount Price</th>
                <th>Code</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {subProducts.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No sub products yet. Click "Add Sub Product".
                  </td>
                </tr>
              ) : (
                subProducts.map((sp, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={sp.size_length}
                        className="form-control"
                        onChange={(e) =>
                          handleSubProductChange(index, "size_length", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={sp.color}
                        className="form-control"
                        onChange={(e) =>
                          handleSubProductChange(index, "color", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={sp.qty}
                        className="form-control"
                        onChange={(e) =>
                          handleSubProductChange(index, "qty", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={sp.price}
                        className="form-control"
                        onChange={(e) =>
                          handleSubProductChange(index, "price", parseFloat(e.target.value))
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={sp.discounted_price}
                        className="form-control"
                        onChange={(e) =>
                          handleSubProductChange(index, "discounted_price", parseFloat(e.target.value))
                        }
                      />
                    </td>
                    <td>{sp.product_code}</td>
                    <td>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDeleteSubProduct(index)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              )}
              <tr>
                <td colSpan="4" className="text-center">
                  <Button color="primary" onClick={handleAddSubProduct}>
                    + Add Sub Product
                  </Button>
                </td>
                 <td colSpan="4" className="text-center">
                 {loadInser2 ?
              <button type="button" className="btn btn-primary ">
                Saving..
              </button> :  <button
            type="button"
            onClick={handleSave} // 🔹 Alert trigger
            className="btn btn-primary"
          >
            Save All SubProduct
          </button>}
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

    
    </>
  );
};

export default SubProductsTable;
